import { keywords } from "../keywords.js";

/**
 * Checks if the given value is a JavaScript module (ESM).
 * Uses the `Symbol.toStringTag` property for identification.
 * 
 * @param value - The value to check.
 * @returns True if the value is a module.
 */
export function isModule(value: any): boolean {
  return value[Symbol.toStringTag] === keywords.moduleTag
}
